import React from 'react'

import { useSessionMetadataOrFail } from '../../../hooks/useSessionMetadataOrFail'
import IcaewConsentModal from './components/IcaewConsentModal'
import IcaewPricingModal from './components/IcaewPricingModal'

const IcaewModals: React.FC = () => {
  const icaewModals = useSessionMetadataOrFail().icaewModals

  if (icaewModals?.showPricingModal) {
    return <IcaewPricingModal />
  }

  if (icaewModals?.showDataSharingModal) {
    return <IcaewConsentModal />
  }

  return null
}

export default IcaewModals
